export default __webpack_public_path__ + "static/media/poly.d63b6a18.jpeg";